import { FileText, Home, ShoppingBag } from "lucide-react";

/** Cabinet sections, shared by the desktop sidebar and the mobile AccountSectionNav. */
export const ACCOUNT_SECTIONS = [
  { id: "dashboard", label: "Главная", icon: Home, path: "/account" },
  { id: "orders", label: "Мои заказы", icon: ShoppingBag, path: "/account/orders" },
  { id: "documents", label: "Документы", icon: FileText, path: "/account/documents" },
];

/** "/account" matches only itself; deeper sections also match their sub-paths. */
export const isSectionActive = (path: string, currentPath: string) =>
  currentPath === path || (path !== "/account" && currentPath.startsWith(path));
